import { useState } from 'react';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { errorHandlerContext } from '../contexts';
import { ToastAction } from '../Redux/Actions/ToastAction';

export function useProvideErrorHandler() {
  const dispatch = useDispatch();
  const handleClose = () => {
    setMsgConfig({
      ...msgConfig,
      alertOpen: false,
    });
    dispatch(ToastAction({ hide: true }));
  };

  const defaultMsgConfig = {
    alertOpen: false,
    handleClose,
    message: 'Loading...',
    severity: 'info',
  };

  const [msgConfig, setMsgConfig] = useState(defaultMsgConfig);

  return {
    msgConfig,
    setMsgConfig,
    handleClose,
  };
}
export function useErrorHandler() {
  return useContext(errorHandlerContext);
}
